<template>
  <section class="federated-login">
    <h1 class="federated-login__message">You are being logged in!</h1>
    <div class="federated-login__spinner-wrapper">
      <ActionLoader
        loaderClass="federated-login__spinner"
        name="ball-clip-rotate"
      />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import { setTokens } from '@/helpers'

export default {
  name: 'FederatedLogin',
  components: {
    ActionLoader,
  },
  metaInfo() {
    return {
      title: `INE - Federated Login`,
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
      isTwoFactorRequired: state => state.auth.isTwoFactorRequired,
      redirectUrl: state => state.auth.redirectUrl,
    }),
  },
  methods: {
    async attemptLogin() {
      const { Bearer, Refresh } = this.getTokensFromParams()
      await setTokens({ Bearer, Refresh })
      await this.$store.dispatch('auth/federatedLogin')
      if (this.isTwoFactorRequired) {
        this.$router.push({ name: 'two-factor' })
        return
      }
      if (this.isAuthenticated) {
        if (!this.redirectUrl) {
          this.$router.push({ name: 'home' })
        } else {
          window.location.assign(this.redirectUrl)
        }
      }
    },
    getTokensFromParams() {
      const params = new URLSearchParams(window.location.search)
      return {
        Bearer: params.get('access_token'),
        Refresh: params.get('refresh_token'),
      }
    },
  },
  async created() {
    this.$store.dispatch('auth/restoreRedirectUrl')
    await this.attemptLogin()
  },
}
</script>

<style lang="scss" scoped>
.federated-login {
  padding-top: 150px;
  height: 100%;
  @include tablet {
    padding-top: 300px;
  }
  &__message {
    margin: 0 auto;
    text-align: center;
    color: var(--white);
    font-size: 2rem;
  }
  &__spinner-wrapper {
    width: 100%;
    color: var(--orange);
    margin: 20px auto 0 auto;
    text-align: center;
  }
}
</style>
